<template>
  <span>    
    <span v-show="item.edited == '1'" >
      <p v-if="item.output == 'paragraph'" class="mt-2 editForm">
        <nl2br tag="span" :text="item.value"></nl2br> <br />
         <i class="fal fa-times-circle" @click="removeEdit"  v-b-tooltip.hover :title="$t('TEMPLATE.FORM.REMOVE')" />
      </p>
      <span v-if="item.output == 'line'" class="editForm">
        <nl2br tag="span" :text="item.value"></nl2br>  <br />   
        <i class="fal fa-times-circle" @click="removeEdit"  v-b-tooltip.hover :title="$t('TEMPLATE.FORM.REMOVE')" />
      </span>
    </span>
    <b-card no-body v-show="item.edited  == '0'" class="mt-2">
      <b-card-body>
        <b-form-textarea class="p-2 mt-2" v-model="item.value" v-on:keyup.enter="saveForm" rows="3" max-rows="8" no-auto-shrink></b-form-textarea>             
      </b-card-body>
      <b-card-footer>
        <b-button class="float-right mt-2 btn-fill" @click="saveForm">Save</b-button>
      </b-card-footer>
    </b-card>
  </span>
</template>
<script>
export default {
  props: ["value","templateId"],
  data() {
    return {
      item: this.value,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    saveForm: function() {
      let self = this;
      this.$http.post(process.env.VUE_APP_BACKEND + "/template/document/answer/update", {
        templateId: this.templateId,
        answers:  [{
          Key: this.item.id,
          Value: this.item.value
        }]
      })
      .then(function() {
        self.item.edited = "1";
        self.$emit("input",self.item);
      })
      .catch(function() {
        self.$noty.error(self.$t("ERROR.COULD_NOT_SAVE"));
      });        
    },
    removeEdit: function() {
      this.item.edited = "0";
    }
  },
  mounted: function() {
  }
};
</script>
<style>
</style>